<template>
  <div class="error-container">
    <h1 class="error-title">{{ $t("PAGE 404") }}</h1>
    <p class="error-notification is-info">
      {{ $t("Not found") }}
      <router-link class="button is-white back-btn" to="/">{{
        $t("GET BACK HOME")
      }}</router-link>
    </p>
  </div>
</template>
<script>
import GlobalMixin from "@/GlobalMixin.js"

export default {
  mixins: [GlobalMixin],
}
</script>

<style scoped lang="scss">
.error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 65vh;
  text-align: center;

  .error-title {
    font-size: 2.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: $error;
  }

  .error-notification {
    font-size: 1.6rem;
    font-weight: 600;
    margin-top: 1rem;
    padding: 1rem 2rem;
    border-radius: 0.5rem;
    color: $title;
  }

  .back-btn {
    margin-left: 1rem;
    font-size: 1.3rem;
    background-color: $hover-green;
    color: white;
    font-weight: bold;
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    transition: background-color 0.3s ease;
    text-decoration: none;
    &:hover {
      opacity: 0.9;
      color: white;
    }
  }
}
</style>
